












import { defineComponent } from "@vue/composition-api";
import { CreditCardAssignment } from "@scrile/api-provider/dist/api/CreditCardAssignmentsProvider";
import { RecurringBillingSchedule } from "@scrile/api-provider/dist/api/RecurringBillingScheduleProvider";
import { Subscription, SubscriptionsSearchResult } from "@scrile/api-provider/dist/api/SubscriptionProvider";
import useAuthUser from "@/hooks/useAuthUser";
import useSystemSettings from "@/hooks/useSystemSettings";
import providers from "@/lib/api";
import PageManageSubscriptionsView from "./components/PageManageRecurringView";

export default defineComponent({
  name: "PageManageRecurring",
  components: { PageManageSubscriptionsView },
  setup() {
    const { authUserStrict } = useAuthUser();
    const { creditCardAllowed } = useSystemSettings();
    return {
      authUserStrict,
      creditCardAllowed,
    };
  },
  data() {
    return {
      response: null as SubscriptionsSearchResult | null,
      creditCardList: [] as CreditCardAssignment[],
      canceling: false,
      loading: false,
      scroll: true,
    };
  },
  computed: {
    list(): Subscription[] {
      return this.response?.result ?? [];
    },
    creditCard(): CreditCardAssignment | null {
      return this.creditCardList.length > 0 ? this.creditCardList[0] : null;
    },
  },
  methods: {
    onNext(cb?: Function) {
      if (!this.response || !this.response.hasNextPage) return;
      this.getData(this.response.page, false).finally(() => cb && cb());
    },
    async onCancel(rebill: RecurringBillingSchedule, cb: Function) {
      try {
        if (!this.response) return;
        this.canceling = true;
        const response = await providers.RecurringBillingScheduleProvider.cancel({
          data: { id: rebill.id, removeAccess: false },
        });
        this.$set(
          this.response,
          "result",
          this.response.result.map(i => {
            if (i.recurringBillingScheduleId === rebill.id && i.recurringBillingSchedule) {
              i.recurringBillingSchedule.cancelled = response;
            }
            return i;
          })
        );
      } finally {
        cb();
        this.canceling = false;
      }
    },
    async getData(page: number = 0, replace = true) {
      if (this.loading) return;
      try {
        this.loading = true;
        this.scroll = false;
        const response = await providers.SubscriptionProvider.search(
          {
            data: { consumerIds: [this.authUserStrict.id], sort: "CREATE_TIME,DESC", page },
          },
          [
            "amount",
            "createTime",
            "expirationTime",
            "id",
            "recurringBillingScheduleId",
            { consumer: ["username"] },
            {
              provider: [
                "id",
                "username",
                "screenName",
                { avatar: ["urlPart"] },
                { onlineStatus: ["isOnline"] },
                {
                  publicLivechatUser: ["id"],
                },
              ],
            },
            {
              recurringBillingSchedule: [
                "id",
                "cancelled",
                "lastBillingTime",
                { cost: ["cost"] },
                { schedule: ["nextBillingTime"] },
              ],
            },
          ]
        );
        if (!replace) {
          response.result = [...(this.response?.result ?? []), ...response.result];
        }
        this.response = response;
      } finally {
        this.loading = false;
        this.scroll = this.response?.hasNextPage ?? false;
      }
    },
  },
  async mounted() {
    this.getData();
    if (this.creditCardAllowed) {
      this.creditCardList = await providers.CreditCardAssignmentsProvider.findAll({ userId: this.authUserStrict.id });
    }
  },
});
